module.exports = __webpack_public_path__ + "img/misc_notifications.114393d1.svg";